import { ContentListService } from "../../basic/path"
import RequestModel from "../../basic/requestConfig";

export default {
    getContentTagList(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: ContentListService.getContentTagList,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {}
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
    getContentTagByPid(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: ContentListService.getContentTagByPid,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {}
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
    addContentTag(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                method: 'post',
                url: ContentListService.addContentTag,
                data: query.data ? query.data : {},
                params: query.params ? query.params : {},
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
            }),
            request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        }); 
    },
    updateContentTag(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                method: 'post',
                url: ContentListService.updateContentTag,
                data: query.data ? query.data : {},
                params: query.params ? query.params : {},
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
            }),
            request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        }); 
    },
    deleteContentTag(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                method: 'get',
                url: ContentListService.deleteContentTag,
                data: query.data ? query.data : {},
                params: query.params ? query.params : {}
            }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    }

}
